// import React, { useState } from "react";
// import { FaUserPlus, FaMoneyCheckAlt, FaChartLine, FaCalendarCheck ,FaChevronUp,FaChevronDown} from "react-icons/fa";

// const LmsFeatures = () => {
//   const [showMore, setShowMore] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   const styles = {
//     container: {
//       display: "flex",
//       flexDirection: "column",
//       padding: "20px",
//       justifyContent: "center",
//       alignItems: "center",
//       gap: "30px",
//       maxWidth: "1200px",
//       margin: "0 auto",
//       fontFamily: "'Arial', sans-serif",
//     },
//     contentWrapper: {
//       display: "flex",
//       flexWrap: "wrap",
//       justifyContent: "center",
//       alignItems: "flex-start",
//       gap: "40px",
//       width: "100%",
//     },
//     left: {
//       flex: "1 1 350px",
//       maxWidth: "500px",
//     },
//     smallHeading: {
//       color: "#025261",
//       fontWeight: "600",
//       fontSize: "clamp(20px, 4vw, 28px)",
//       letterSpacing: "1px",
//       marginBottom: "8px",
//     },
//     heading: {
//       fontSize: "clamp(16px, 3vw, 18px)",
//       fontWeight: "bold",
//       marginBottom: "16px",
//       letterSpacing: "0px",
//       color: "#333",
//     },
//     description: {
//       fontSize: "clamp(14px, 2.5vw, 15px)",
//       color: "#555",
//       lineHeight: "1.6",
//       marginBottom: "20px",
//       textAlign: "justify",
//     },
//     button: {
//       padding: "10px 20px",
//       border: "2px solid #025261",
//       background: isHovered ? "#025261" : "transparent",
//       color: isHovered ? "#fff" : "#000",
//       fontWeight: "600",
//       cursor: "pointer",
//       transition: "0.3s",
//       borderRadius: "4px",
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     right: {
//       display: "grid",
//       gridTemplateColumns: "repeat(2, 1fr)",
//       gridTemplateRows: "repeat(2, 1fr)",
//       gap: "15px",
//       flex: "1 1 350px",
//       maxWidth: "500px",
//       width: "100%",
//     },
//     card: {
//       height: "150px",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "center",
//       color: "#fff",
//       fontWeight: "600",
//       fontSize: "clamp(14px, 2vw, 16px)",
//       textAlign: "center",
//       padding: "10px",
//       borderRadius: "10px",
//       animation: "float 3s ease-in-out infinite, fadeUp 1s ease forwards",
//       opacity: 0, // start invisible
//     },
//     card1: { background: "#29b6f6", animationDelay: "0.1s" },
//     card2: { background: "#fbc02d", animationDelay: "0.3s" },
//     card3: { background: "#f57c00", animationDelay: "0.5s" },
//     card4: { background: "#ec407a", animationDelay: "0.7s" },
//     expandedContent: {
//       maxWidth: "800px",
//       width: "100%",
//       padding: "20px",
//       backgroundColor: "#f9f9f9",
//       borderRadius: "8px",
//       marginTop: "20px",
//       borderLeft: "4px solid #fbc02d",
//       animation: "fadeIn 0.5s ease forwards",
//     },
//     expandedRow: {
//       display: "flex",
//       flexDirection: "row",
//       alignItems: "flex-start",
//       gap: "20px",
//     },
//     expandedText: {
//       flex: "1 1 60%",
//     },
//     imageContainer: {
//       flex: "1 1 40%",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       padding: "15px",
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//     },
//     image: {
//       maxWidth: "100%",
//       height: "auto",
//       maxHeight: "170px",
//     },
//     mobileLogoFirst: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "20px",
//     },
//   };

//   return (
//     <>
//       {/* Keyframes for animation */}
//       <style>
//         {`
//           @keyframes float {
//             0%, 100% { transform: translateY(0); }
//             50% { transform: translateY(-8px); }
//           }
//           @keyframes fadeUp {
//             from { transform: translateY(30px); opacity: 0; }
//             to { transform: translateY(0); opacity: 1; }
//           }
//           @keyframes fadeIn {
//             from { opacity: 0; transform: translateY(-10px); }
//             to { opacity: 1; transform: translateY(0); }
//           }
//           @media (max-width: 768px) {
//             .content-wrapper {
//               flex-direction: column;
//               align-items: center;
//             }
//             .right-grid {
//               grid-template-columns: repeat(2, 1fr);
//             }
//             .expanded-row {
//               flex-direction: column;
//             }
//             .logo-first-on-mobile {
//               flex-direction: column;
//             }
//             .logo-first-on-mobile .image-container {
//               order: 1;
//               margin-bottom: 20px;
//             }
//             .logo-first-on-mobile .expanded-text {
//               order: 2;
//             }
//           }
//           @media (max-width: 480px) {
//             .right-grid {
//               grid-template-columns: 1fr;
//               grid-template-rows: repeat(4, 1fr);
//             }
//           }
//         `}
//       </style>

//       <div style={styles.container}>
//         <div style={styles.contentWrapper} className="content-wrapper">
//           {/* Left Side */}
//           <div style={styles.left}>
//             <div style={styles.smallHeading}>Our Features</div>
//           <h2 style={styles.heading}>HRMS System Features</h2>
//           <p style={styles.description}>
//             Our HRMS platform streamlines workforce management with powerful tools
//             for onboarding, payroll, performance tracking, and leave management —
//             enabling a more productive and engaged team.
//           </p>
//             <button
//               style={styles.button}
//               onMouseEnter={() => setIsHovered(true)}
//               onMouseLeave={() => setIsHovered(false)}
//               onClick={() => setShowMore(!showMore)}
//               aria-expanded={showMore}
//             >
//               {showMore ? "VIEW LESS" : "VIEW MORE"}
//               {showMore ? <FaChevronUp /> : <FaChevronDown />}
//             </button>
//           </div>

//           {/* Right Side - 2x2 Grid */}
//           <div style={styles.right}>
//           <div style={{ ...styles.card, ...styles.card1 }}>
//             <FaUserPlus size={32} style={{ marginBottom: "10px" }} />
//             Employee Onboarding
//           </div>
//           <div style={{ ...styles.card, ...styles.card2 }}>
//             <FaMoneyCheckAlt size={32} style={{ marginBottom: "10px" }} />
//             Payroll Management
//           </div>
//           <div style={{ ...styles.card, ...styles.card3 }}>
//             <FaChartLine size={32} style={{ marginBottom: "10px" }} />
//             Performance Tracking
//           </div>
//           <div style={{ ...styles.card, ...styles.card4 }}>
//             <FaCalendarCheck size={32} style={{ marginBottom: "10px" }} />
//             Leave Management
//           </div>
//         </div>
//         </div>

//         {/* Expanded Content */}
//         {showMore && (
//           <div style={styles.expandedContent}>
//             <div style={styles.expandedRow} className="logo-first-on-mobile">
//               {/* IIA Logo - Will appear first on mobile */}
//               <div style={styles.imageContainer} className="image-container">
//                 <img
//                   src="/image/hrms l.png"
//                   alt="IIA LMS"
//                   style={styles.image}
//                   onError={(e) => {
//                     e.target.onerror = null;
//                     e.target.src = "https://via.placeholder.com/300x100/ffdd00/000000?text=IIA+Logo";
//                   }}
//                 />
//               </div>

//               {/* Content - Will appear below logo on mobile */}
//               <div style={styles.expandedText} className="expanded-text">
//                 <h2 style={styles.heading}>Revolutionize HR Management with Envision HRMS</h2>
//                 <p style={styles.description}>
//                  Streamline your workforce management with Envision HRMS — an all-in-one Human Resource
//                   Management System designed to simplify HR processes, automate workflows, and improve
//                   employee engagement. From recruitment and onboarding to payroll, performance tracking,
//                    and compliance, our platform ensures accuracy, transparency, and efficiency across your
//                     organization
//                 </p>

//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default LmsFeatures;

import React, { useState } from "react";
import {
  FaUserPlus,
  FaMoneyCheckAlt,
  FaChartLine,
  FaCalendarCheck,
  FaChevronUp,
  FaChevronDown,
  FaExternalLinkAlt,
} from "react-icons/fa";

const LmsFeatures = () => {
  const [showMore, setShowMore] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleVisitNow = () => {
    // Replace with your actual website URL
    window.open("https://actus.iiautomate.com/", "_blank");
  };
   

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      padding: "20px",
      justifyContent: "center",
      alignItems: "center",
      gap: "30px",
      maxWidth: "1200px",
      margin: "0 auto",
      fontFamily: "'Arial', sans-serif",
    },
    contentWrapper: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "40px",
      width: "100%",
    },
    left: {
      flex: "1 1 350px",
      maxWidth: "500px",
    },
    smallHeading: {
      color: "#025261",
      fontWeight: "600",
      fontSize: "clamp(20px, 4vw, 28px)",
      letterSpacing: "1px",
      marginBottom: "8px",
    },
    heading: {
      fontSize: "clamp(16px, 3vw, 18px)",
      fontWeight: "bold",
      marginBottom: "16px",
      letterSpacing: "0px",
      color: "#333",
    },
    description: {
      fontSize: "clamp(14px, 2.5vw, 15px)",
      color: "#555",
      lineHeight: "1.6",
      marginBottom: "20px",
      textAlign: "justify",
    },
    button: {
      padding: "10px 20px",
      border: "2px solid #025261",
      background: isHovered ? "#025261" : "transparent",
      color: isHovered ? "#fff" : "#000",
      fontWeight: "600",
      cursor: "pointer",
      transition: "0.3s",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    visitButton: {
      padding: "10px 20px",
      border: "none",
      background: "#fbc02d",
      color: "#000",
      fontWeight: "600",
      cursor: "pointer",
      transition: "0.3s",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "15px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    },
    right: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gridTemplateRows: "repeat(2, 1fr)",
      gap: "15px",
      flex: "1 1 350px",
      maxWidth: "500px",
      width: "100%",
    },
    card: {
      height: "150px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "#fff",
      fontWeight: "600",
      fontSize: "clamp(14px, 2vw, 16px)",
      textAlign: "center",
      padding: "10px",
      borderRadius: "10px",
      animation: "float 3s ease-in-out infinite, fadeUp 1s ease forwards",
      opacity: 0, // start invisible
    },
    card1: { background: "#29b6f6", animationDelay: "0.1s" },
    card2: { background: "#fbc02d", animationDelay: "0.3s" },
    card3: { background: "#f57c00", animationDelay: "0.5s" },
    card4: { background: "#ec407a", animationDelay: "0.7s" },
    expandedContent: {
      maxWidth: "800px",
      width: "100%",
      padding: "20px",
      backgroundColor: "#f9f9f9",
      borderRadius: "8px",
      marginTop: "20px",
      borderLeft: "4px solid #fbc02d",
      animation: "fadeIn 0.5s ease forwards",
    },
    expandedRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      gap: "20px",
    },
    expandedText: {
      flex: "1 1 60%",
    },
    imageContainer: {
      flex: "1 1 40%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "15px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    },
    image: {
      maxWidth: "100%",
      height: "auto",
      maxHeight: "170px",
    },
    mobileLogoFirst: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
  };

  return (
    <>
      {/* Keyframes for animation */}
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }
          @keyframes fadeUp {
            from { transform: translateY(30px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @media (max-width: 768px) {
            .content-wrapper {
              flex-direction: column;
              align-items: center;
            }
            .right-grid {
              grid-template-columns: repeat(2, 1fr);
            }
            .expanded-row {
              flex-direction: column;
            }
            .logo-first-on-mobile {
              flex-direction: column;
            }
            .logo-first-on-mobile .image-container {
              order: 1;
              margin-bottom: 20px;
              width: 100%;
              flex: none;
            }
            .logo-first-on-mobile .expanded-text {
              order: 2;
              width: 100%;
              flex: none;
            }
          }
          @media (max-width: 480px) {
            .right-grid {
              grid-template-columns: 1fr;
              grid-template-rows: repeat(4, 1fr);
            }
            .expanded-content {
              padding: 15px;
            }
            .expanded-row {
              gap: 15px;
            }
          }
        `}
      </style>

      <div style={styles.container}>
        <div style={styles.contentWrapper} className="content-wrapper">
          {/* Left Side */}
          <div style={styles.left}>
            <div style={styles.smallHeading}>Our Features</div>
            <h2 style={styles.heading}>HRMS System Features</h2>
            <p style={styles.description}>
              Our HRMS platform streamlines workforce management with powerful
              tools for onboarding, payroll, performance tracking, and leave
              management — enabling a more productive and engaged team.
            </p>
            <button
              style={styles.button}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => setShowMore(!showMore)}
              aria-expanded={showMore}
            >
              {showMore ? "VIEW LESS" : "VIEW MORE"}
              {showMore ? <FaChevronUp /> : <FaChevronDown />}
            </button>
          </div>

          {/* Right Side - 2x2 Grid */}
          <div style={styles.right}>
            <div style={{ ...styles.card, ...styles.card1 }}>
              <FaUserPlus size={32} style={{ marginBottom: "10px" }} />
              Employee Onboarding
            </div>
            <div style={{ ...styles.card, ...styles.card2 }}>
              <FaMoneyCheckAlt size={32} style={{ marginBottom: "10px" }} />
              Payroll Management
            </div>
            <div style={{ ...styles.card, ...styles.card3 }}>
              <FaChartLine size={32} style={{ marginBottom: "10px" }} />
              Performance Tracking
            </div>
            <div style={{ ...styles.card, ...styles.card4 }}>
              <FaCalendarCheck size={32} style={{ marginBottom: "10px" }} />
              Leave Management
            </div>
          </div>
        </div>

        {/* Expanded Content */}
        {showMore && (
          <div style={styles.expandedContent} className="expanded-content">
            <div
              style={styles.expandedRow}
              className="expanded-row logo-first-on-mobile"
            >
              {/* IIA Logo - Will appear first on mobile */}
              <div style={styles.imageContainer} className="image-container">
                <img
                  src="/image/hrms l.png"
                  alt="IIA LMS"
                  style={styles.image}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/300x100/ffdd00/000000?text=IIA+Logo";
                  }}
                />
              </div>

              {/* Content - Will appear below logo on mobile */}
              <div style={styles.expandedText} className="expanded-text">
                <h2 style={styles.heading}>
                  Revolutionize HR Management with Envision HRMS
                </h2>
                <p style={styles.description}>
                  Streamline your workforce management with Envision HRMS — an
                  all-in-one Human Resource Management System designed to
                  simplify HR processes, automate workflows, and improve
                  employee engagement. From recruitment and onboarding to
                  payroll, performance tracking, and compliance, our platform
                  ensures accuracy, transparency, and efficiency across your
                  organization
                </p>

                {/* Visit Now Button */}
                <button style={styles.visitButton} onClick={handleVisitNow}>
                  VISIT NOW <FaExternalLinkAlt />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LmsFeatures;
